<template>
   <div class="d-flex justify-content-center">
      <div v-if="cellTable">
         <div class="tbl-btn rounded">
            <div class="p-1 hl-sty">
            </div>
               <table class="table table-borderless mb-0">  <!-- table-border(ed/less) -->
                  <tbody>
                     <!-- 
            {{cellTable}}
                  {{cellCardTypes}}
                     -->
                     <tr>
                        <td class="py-0 td-wd">
                           <div class="card px-3 bg-transparent border-0">
                              <div class="row">
                              <b class="p-0 fs-15 col-11">{{cellTable.name}}</b>
                              <button class="btn btn-sm btn-card col-1 align-self-start"  
                                 type="button" 
                                 data-bs-toggle="modal" data-bs-target="#cellAction" 
                                 :data-cell-id="cellTable.id"
                                 :data-cell-name="cellTable.name" 
                                 >
                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                 </svg>
                              </button>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            <!-- clmn-1 
            -->
            <div class="table-responsive" :class="cellsInBox == 2 ? 'clmn-2' : 'clmn-1'">
               <!--
               -->
               <table class="table table-borderless mb-0">  <!-- table-border(ed/less) -->
                  <tbody>
                     <!-- 
                           :disabled="false"
                     -->
                     <tr>
                        <draggable 
                           tag="td"
                           v-model="cellContent"
                           group="cards" 
                           @start="onStart" 
                           @change="onChange($event, cellTable.id)"
                           item-key="index"
                           :disabled="!cellTable.canCardsInOut"
                           >
                           <template #header v-if="typeof cellContent[0] === 'undefined'">
                              <div class="card" style="background-color: rgb(225, 225, 225);">
                                 <div class="card-header bg-transparent">Lista sin Contenido</div>
                              </div>
                           </template>
                           <!-- 
                           <template #item="{element}" class="p-1">
                           <template #item="{element}">
                              <Content :content="element" :cell_id="cellTable.id" class="p-0"/>
                           -->
                           <template #item="{element}">
                              <Content :content="element" :cell_id="cellTable.id"/>
                           </template>
                           <!--
                           -->
                        </draggable>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div class="row ps-3">
               <div class="col">
                  <!--
                  <button v-show="false" id="addCardButton"
                     type="button" class="btn btn-sm btn-card"  
                     data-bs-toggle="modal" data-bs-target="#mdContent" 
                     :data-cntt-id="0" 
                     :data-cell-id="cellTable.id"
                     :data-column-id="column"
                  >
                     <b>+ Tarjeta</b>
                  </button>
                     :style="{'background-color': board_bg_color}">
                        :data-cell-card-types="cellCardTypes"
                                      -->                  
                  <div v-if="addOnOff">
                  <button v-show="false" id="addCardButton"
                     type="button" class="btn btn-sm btn-card"  
                     data-bs-toggle="modal" data-bs-target="#mdNewContent" 
                     :data-card-type-id="cardTypeId"
                     :data-cell-id="cellTable.id"
                     :data-cell-name="cellTable.name"
                     :data-board-id="board.id"
                  >
                     <b>+ Tarjeta</b>
                  </button>
                  </div>
                  <div v-if=" cellTable.multiCard " class="row row-cols-auto d-flex justify-content-start ps-1 pt-1">
                     <button 
                        type="button" class="btn btn-sm btn-card border shadow" 
                        @click=" multiCardSelect = true " 
                           >
                        <b>+ Tarjeta</b>
                     </button>
                  </div>
                  <div v-else class="row row-cols-auto d-flex justify-content-start">
                     <div v-for="(rectangleCard, index) in cellCardTypes" :key="index" 
                           class="col p-0 pt-1 ms-1 tj-foot-cell"
                           @click="addCard(rectangleCard.id, rectangleCard.titleForm, index)"
                           >
                        <!-- {{rectangleCard.capitals}} -->
                        <CardRectangle :rectangleCard="rectangleCard" />
                     </div>
                  </div>
               </div>
               <nav aria-label="Cell page navigation" class="col pgnav pt-1">
                  <ul class="pagination pagination-sm justify-content-end">
                     <a v-if="loading" class="page-link tbl-btn">
                        <span class="spinner-grow spinner-grow-sm"></span>
                     </a>
                     <li class="page-item"><a class="page-link tbl-btn">{{totalCards}}</a></li>
                     <li v-if="totalPages > 0" class="page-item">
                        <a class="page-link tbl-btn" href="#" v-on:click="addPageNumber(-1)" aria-label="Previous" :disabled="loading">
                           <span aria-hidden="true">&lt;</span>
                        </a>
                        <!--
                        -->
                     </li>
                     <li v-if="totalPages > 0" class="page-item"><a class="page-link tbl-btn">{{pageNumberTotalCards}}</a></li>
                     <li v-if="totalPages > 0" class="page-item">
                        <a class="page-link tbl-btn" href="#" v-on:click="addPageNumber(1)" aria-label="Next">
                           <span aria-hidden="true">&gt;</span>
                        </a>
                        <!--
                        -->
                     </li>
                  </ul>
               </nav>
            </div>
         </div>
      </div>
      <multi-card-select 
         v-if="multiCardSelect" 
         :cellId="cellTable.id"
         :cellName="cellTable.name"
         :cellCards="cellCardTypes"
         @cancel="multiCardSelect = false"
         @selected="(val) => sendSelected(val)"
      />
      <input-form
         v-if="inputFormTitle" 
         :startedBy="startedBy"
         :cardType="cellCardTypes[indexCardType]"
         :cellId="cellTable.id"
         @cancel="inputFormTitle = false"
      />
      <select-initiator
         v-if="selectInitOk"
         :selectInitiator="selectInitiator"
         :cardType="cellCardTypes[indexCardType]"
         @cancel="selectInitOk = false"
         @selected="(val) => startTitle(val)"
      />
   </div>
   <!--
   <MdContent/>
     -->
</template>

<script>
import draggable from 'vuedraggable'
import Content from './ContentTableTypeList.vue';
import WspService from "../workSpace.service";
import CardRectangle from "./CardRectangle.vue";

import MultiCardSelect from './form/MultiCardSelect.vue';
import InputForm from './form/InputForm.vue';
import SelectInitiator from './form/SelectInitiator.vue';

export default {
   name: 'CellTable',
   components: {
      draggable,
      Content,
      CardRectangle,
      MultiCardSelect,
      InputForm,
      SelectInitiator
   },
   props: {
      board: {
         type: Object
      },
      row: {
         type: Number
      },
      column: {
         type: Number
      },
      cellsInBox: {
        type: Number 
      },
   },
   data() {
      return {
         cellTable: null,
         cellContent: null,
         netError: false,
         countDown : 5,
         iscountDownOn: true,
         cellMilli: 0,
         fieldPicked: 'ID',
         orderPicked: 'desc',
         totalCards: 0,
         totalPages: 0,
         actualPage: 0,
         pageNumberTotalCards: '0/0',
         loading: false,
         cellCardTypes: false,

         addOnOff: false,
         cardTypeId: 0,

         filterCardTypeId: 0,
         filterUserId: 0,
         filterLabelId: 0,

         multiCardSelect: false,
         indexCardType: 0,
         inputFormTitle: false,

         selectInitiator: 'AFL',
         selectInitOk: false,
         startedBy: 'AFL'

      };
   },
   mounted() {
      this.$nextTick(() => {
         console.log("cargando celda ("+this.row+","+this.column+")");
         this.tableBox = document.getElementById("table_box");
         this.getCellByPosition(this.board.id, this.row, this.column, true);
      });
   },
   watch: {
      totalPages: function (newTotalPages) {
         if (this.actualPage > newTotalPages) {
            if (newTotalPages > -1) {
               this.actualPage = newTotalPages
               //console.log('watch change totalPage: ' + newTotalPages + ',' + oldTotalPage)
               this.getCellByPosition(this.board.id, this.row, this.column, false);
            }
         }
      },
      //
      board: function (newBoard) {
         this.getCellByPosition(newBoard.id, this.row, this.column, false);
      }
      //
   },
   methods: {
      //
      countDownTimer() {
         if (this.iscountDownOn) {
            if (!this.netError) {
               if(this.countDown > 0) {
                  setTimeout(() => {
                     this.countDown -= 1
                     this.countDownTimer()
                  }, 1000)
               } else {
                  if (this.cellTable != null) {
                  let sortParamIndex = this.$store.state.wspace.sortParameters.findIndex((obj => obj.cellId == ""+this.cellTable.id));
                  if (sortParamIndex >= 0) {
                     if (
                        this.fieldPicked != this.$store.state.wspace.sortParameters[sortParamIndex].field ||
                        this.orderPicked != this.$store.state.wspace.sortParameters[sortParamIndex].order
                        ) {
                        this.fieldPicked = this.$store.state.wspace.sortParameters[sortParamIndex].field
                        this.orderPicked = this.$store.state.wspace.sortParameters[sortParamIndex].order
                        this.getCellByPosition(this.board.id, this.row, this.column, false, 0);
                        document.getElementById('bttCloseMdOrder').click();
                     }
                  }
                  this.getCellMilli(this.cellTable.id);
                  }
                  this.countDown = 7;
                  this.countDownTimer();
               }
            }
         }
      },
      //          let uAppIndex = this.$store.state.auth.userAppIndex;
      onStart() {
         console.log("dragStart 0");
         this.$store.dispatch("wspace/setCellName", this.cellTable.name)
         console.log("dragStart 1");
      },
      //
      addPageNumber(addPage) {
         if (((addPage > 0 && this.actualPage + addPage <= this.totalPages) 
               || (addPage < 0 && this.actualPage + addPage >= 0))
               && !this.loading) {
                  this.actualPage += addPage
                  this.getCellByPosition(this.board.id, this.row, this.column, false, this.actualPage);
                  this.pageNumberTotalCards = (this.actualPage+1)+'/'+(this.totalPages+1)
         }
      },
      //
      onChange: function(evt, column) {
         console.log("-----("+column+")-----------------------");
         
         if (typeof evt.moved !== 'undefined') {
            console.log("movi a "+evt.moved.element.resumeContentResponse.title+" (OldIndex: "+evt.moved.oldIndex+" - NewIndex: "+evt.moved.newIndex+")");
            this.changePosition(evt.moved.element.cellContentId, column, evt.moved.oldIndex, evt.moved.newIndex);
            //this.queHice1 = "movi a "+evt.moved.element.name;
         }
         if (typeof evt.removed !== 'undefined') {
            console.log("saque a "+evt.removed.element.resumeContentResponse.title+" (OldIndex: "+evt.removed.oldIndex+")");
            this.changePosition(evt.removed.element.cellContentId, column, evt.removed.oldIndex, null);
            //this.queHice1 = "saque a "+evt.removed.element.name;
         }
         if (typeof evt.added !== 'undefined') {
            console.log("puse a "+evt.added.element.resumeContentResponse.title+" (NewIndex: "+evt.added.newIndex+")");
            console.log("cellContentId: "+evt.added.element.cellContentId);
            this.changePosition(evt.added.element.cellContentId, column, null, evt.added.newIndex);
            console.log(this.$store.state.wspace.cellName);
            this.addAuditContent(
               evt.added.element.resumeContentResponse.id, // contentId, 
               "RMV", // codeAudit, 
                this.$store.state.auth.user.id,   // userId, 
               this.$store.state.wspace.cellName+" a "+this.cellTable.name   // text
            );
         }
         /*
         */
      },
      //
      getCellByPosition:function(boardId, row, column, mount) {
         console.log("getCell("+boardId+","+row+","+column+")");
         if (mount) {
            this.fieldPicked = "ID"
            this.orderPicked = "desc"
            this.filterCardTypeId = 0
            this.filterUserId = 0
            this.filterLabelId = 0
         } else {
            this.filterCardTypeId = this.$store.state.wspace.filterCardTypeId
            this.filterUserId = this.$store.state.wspace.filterUserId
            this.filterLabelId = this.$store.state.wspace.filterLabelId
         }
         //console.log("cargando array modulos");
         this.netError = false;
         this.loading = true;
         //WspService.getColumns(1, 1).then(
         WspService.getCellByPosition(
               boardId, 
               row, 
               column, 
               this.fieldPicked, 
               this.orderPicked, 
               this.actualPage,
               this.filterCardTypeId,
               this.filterUserId,
               this.filterLabelId
               ).then(
            (response) => {
               //console.log(response.data);
               this.cellCardTypes = response.data.cellCardTypes;
               this.cellContent = response.data.cellContents;   //.wspContents;
               this.cellTable = response.data.wspCell;
               if (response.data.wspCell != null) {
                  this.cellMilli = response.data.wspCell.milliseconds;
               }
               this.totalCards = response.data.totalCards;
               this.totalPages = response.data.totalPages;
               this.pageNumberTotalCards = (this.actualPage+1)+'/'+(this.totalPages+1);
               this.loading = false;
               console.log("getCell("+row+","+column+")");
               if (mount) {
                  //this.$store.dispatch("wspace/setCellName", this.cellTable.name)
                  let cellTableId = 0;
                  if (this.cellTable) {
                     cellTableId = this.cellTable.id;
                  }
                  this.$store.dispatch("wspace/updateSortParam", {
                     cellId: ""+cellTableId,    //this.cellTable.id,
                     field: this.fieldPicked,
                     order: this.orderPicked
                  })
                  console.log("sortCell("+cellTableId+","+this.fieldPicked+","+this.orderPicked+")");
               }
            },
            (error) => {
               this.content =  
                  (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
               error.message ||
               error.toString();
               //this.content = "Error de sistema (UserAppModules): " + this.content;
               console.log(error);
               this.loading = false;
               this.netError = true;
               //console.log(error.status);
            }
         );
      },
      changePosition(cellContentId, cellId, oldIndex, newIndex) {
         console.log(cellContentId+"/"+cellId);
         //
         WspService.changePosition(cellContentId, cellId, oldIndex, newIndex, this.fieldPicked, this.orderPicked)
         .then(response => {
            console.log(response);
         })
         .catch(error => {
            console.log(error);
         });
      },
      getCellMilli(cellId) {
         //
         WspService.getCellMilli(cellId)
         .then(response => {
            //console.log(response.data);
            if (response.data > this.cellMilli) {
               this.getCellByPosition(this.board.id, this.row, this.column, false);
               document.getElementById('bttCloseOcMoveTo').click();
               //document.getElementById('bttCloseOcMoveShared').click();
            }
            //this.cellMilli = response.data;
         })
         .catch(error => {
            console.log(error);
         });
      },
      addAuditContent(contentId, codeAudit, userId, text) {
         console.log(contentId+";"+codeAudit+";"+userId+";"+text);
         //
         WspService.addAuditContent(
            contentId, 
            codeAudit, 
            userId, 
            text,
            this.cellTable.id,
            null,
            this.board.id
            )
         .then(response => {
            console.log(response);
         })
         .catch(error => {
            console.log(error);
         });
      },
      addCard(cardTypeId, cardTypeTitleForm, index) {
            console.log(cardTypeTitleForm)
         this.cardTypeId = cardTypeId
         if ( cardTypeTitleForm == 'T' ) {
            this.addOnOff = true
            this.$nextTick(() => {
               document.getElementById('addCardButton').click();
               this.addOnOff = false
            })
         }
         if ( cardTypeTitleForm == 'F' ) {
            this.indexCardType = index
            this.selectInitiator = this.cellCardTypes[index].selectInitiator
            this.startedBy = 'AFL'
            this.$nextTick(() => {
               if ( this.selectInitiator == 'AFL' ) {
                  this.inputFormTitle = true;
               } else {
                  this.selectInitOk = true;
               }
            })
         }
      },
      sendSelected( index ) {
         this.addCard( this.cellCardTypes[index].id, this.cellCardTypes[index].titleForm, index)
      },
      startTitle( startedBy ) {
         this.startedBy = startedBy
         this.$nextTick(() => {
            this.inputFormTitle = true
         })
      }
   },
   //
   created() {
      this.countDownTimer()
   },
   beforeUnmount() {
      this.iscountDownOn = false;
      console.log('antes de desmontar cellTable');
   }
   //
}
</script>

<style scoped>
.td-wd {
   width: 290px;
}
.clmn-1 {
   width: 290px;
   max-height: calc(100vh - 228px);
   background-color: rgb(207, 216, 220);
}
.clmn-2 {
   width: 290px;
   max-height: calc(50vh - 156px);
   background-color: rgb(207, 216, 220);
}
.tbl-btn {
   background-color: rgb(207, 216, 220);  
   color: black;
}
.hl-sty {
   width: 270px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.pgnav {
    height: 38px;
    font-weight: bold;
}
.tj-foot-cell {
   cursor: pointer;
}
/*
   background-color: lightgrey;  
*/
</style>